import { UntypedFormGroup } from '@angular/forms';

export type InlineErrors = Record<string, string | null>;

type ClearValidInlineErrorMode = 'delete' | 'null';

interface UpdateInlineErrorsOptions {
  clearValidWith?: ClearValidInlineErrorMode;
  defaultMessage?: string;
  updateValidity?: boolean;
}

const DEFAULT_REQUIRED_MESSAGE = 'Please complete this field.';

export function updateInlineErrors(
  form: UntypedFormGroup,
  inlineErrors: InlineErrors,
  fieldErrors: Record<string, string> = {},
  {
    clearValidWith = 'null',
    defaultMessage = DEFAULT_REQUIRED_MESSAGE,
    updateValidity = true,
  }: UpdateInlineErrorsOptions = {},
): boolean {
  Object.keys(form.controls).forEach((controlName) => {
    const control = form.controls[controlName];

    if (updateValidity) {
      control?.updateValueAndValidity();
    }

    if (control.valid) {
      if (clearValidWith === 'delete') {
        delete inlineErrors[controlName];
      } else {
        inlineErrors[controlName] = null;
      }
      return;
    }

    inlineErrors[controlName] = fieldErrors[controlName] ?? defaultMessage;
  });

  return form.valid;
}

export function shouldShowInlineError(
  form: UntypedFormGroup,
  inlineErrors: InlineErrors,
  fieldName: string,
  hasSubmitted: boolean,
): boolean {
  const control = form.get(fieldName);

  return (
    !!inlineErrors[fieldName] &&
    (hasSubmitted || !!control?.dirty || !!control?.touched)
  );
}
